<h1 mat-dialog-title>Vincular IP a «{{ data.location_name }}»</h1>

<mat-dialog-content>
  <p>
    Has seleccionado una ubicación cercana, pero tu IP actual no está asociada a ella. Si estás conectado al WiFi de la empresa, puedes
    vincular esta IP para que se sugiera automáticamente la próxima vez.
  </p>
  <p class="hint">
    Si usas <b>los datos del móvil, o el móvil como puente WiFi</b>, no la vincules: esas IPs cambian a menudo y no sirven para identificar
    la ubicación.
  </p>

  <mat-checkbox [ngModel]="link_ip()" (ngModelChange)="link_ip.set($event)">
    Estoy usando el WiFi de la ubicación y no el de mi móvil; vincular esta IP a la ubicación
  </mat-checkbox>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Continuar sin vincular</button>
  <button mat-flat-button color="accent" type="button" (click)="confirm()" [disabled]="!link_ip()">Registrar y vincular</button>
</mat-dialog-actions>
